//获取url中的参数
/**
 *
 * @param {*} name 要获取的字段
 * @param {*} type 当type为hash时使用 window.location.hash.split("?")[1];
 */
function getUrlParam(name, type = null) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  console.log(window.location.search)//?id=2
  var r
  if (type === 'hash') {
    r = window.location.hash.split("?")[1].match(reg);
  } else {
    r = window.location.search.substr(1).match(reg);
  }
  if (r !== null) return unescape(r[2]);
  return null;
}

export default {
  getUrlParam
}



// WEBPACK FOOTER //
// ./static/js/function/url.js